import React from "react";

/** Remove the inline markup used to identify friend/highlight substitutions. */
export function stripCueMarkup(content: string): string {
  return content.replace(/<\/?(?:f|h)>/g, "");
}

/**
 * Parses cue content for <f>name</f> tags and renders them as highlighted spans.
 * Returns plain string if no tags found (for backwards compat).
 */
export function renderCueContent(content: string): React.ReactNode {
  if (!content.includes("<f>")) return content;

  const parts: React.ReactNode[] = [];
  let remaining = content;
  let key = 0;

  while (remaining.length > 0) {
    const start = remaining.indexOf("<f>");
    if (start === -1) {
      parts.push(remaining);
      break;
    }
    if (start > 0) {
      parts.push(remaining.slice(0, start));
    }
    const end = remaining.indexOf("</f>", start);
    if (end === -1) {
      parts.push(remaining);
      break;
    }
    const name = remaining.slice(start + 3, end);
    parts.push(
      <span key={key++} style={{ fontWeight: 700 }}>
        {name}
      </span>
    );
    remaining = remaining.slice(end + 4);
  }

  return <>{parts}</>;
}
